export default __webpack_public_path__ + "static/banner-media-release-asia-e3792025b544cde5bee7f48aeb02d741.jpg";